export const getOptimizelyData = () => {
    if (typeof window !== 'undefined') {
        const getCookie = (name) => {
            const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
            return match ? decodeURIComponent(match[1]) : null;
        };
        return {
            experiment_exposures: getCookie('experiment_exposures'),
            experiment_user_ID: getCookie('optimizelyEndUserId'),
        };
    }
    return { experiment_exposures: null, experiment_user_ID: null };
};
